// Global app state — replaces hardcoded mock data

import type { AuthUser, Level, ReferralStats } from './api/client';
import { syncUserCacheCoins } from './api/client';
import type { TournamentState } from './types/tournament';

export interface AppState {
  user: AuthUser | null;
  games: any[];
  levels: Record<string, Level[]>;
  isLoading: boolean;
  referralStats: ReferralStats | null;
  difficultyRange: string | null; // 'easy' | 'medium' | 'hard' | null (null = все)
  tournament: TournamentState | null;
}

export const state: AppState = {
  user: null,
  games: [],
  levels: {},
  isLoading: true,
  referralStats: null,
  difficultyRange: 'easy',
  tournament: null,
};

export function updateCoins(newAmount: number, animate = false) {
  if (!state.user) return;
  const prevAmount = state.user.coins;
  state.user.coins = newAmount;
  syncUserCacheCoins(newAmount);

  if (animate && newAmount > prevAmount) {
    import('./ui/coinAnimation').then(({ animateCoinsAdd, showCoinBurst }) => {
      document.querySelectorAll<HTMLElement>('[data-coin-amount]').forEach(el => {
        animateCoinsAdd(el, prevAmount, newAmount);
      });
      showCoinBurst(newAmount - prevAmount);
    });
  }
}

export function isPremiumActive(): boolean {
  if (!state.user?.is_premium) return false;
  const exp = state.user.premium_expires_at;
  if (exp === null || exp === undefined) return true;
  const expSec = typeof exp === 'number' ? exp : parseInt(String(exp), 10);
  if (!Number.isFinite(expSec)) return true;
  return expSec > Math.floor(Date.now() / 1000);
}
